var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetGoing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11C3 8.79086 4.79086 7 7 7H41C43.2091 7 45 8.79086 45 11V15H3V11Z",
    fill: "#E9F0FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 11,
    r: 1,
    fill: "#256BFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 11,
    r: 1,
    fill: "#256BFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 11,
    r: 1,
    fill: "#256BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6C4.23858 6 2 8.2386 2 11.0001V36.581C2 39.3425 4.23858 41.5811 7 41.5811H41C42.2274 41.5811 43.4565 41.3196 44.4075 40.6441C45.4052 39.9354 46 38.836 46 37.4197V34.8121C46 34.2598 45.5523 33.8121 45 33.8121C44.4477 33.8121 44 34.2598 44 34.8121V37.4197C44 38.2126 43.6994 38.6939 43.2493 39.0135C42.7526 39.3664 41.9818 39.581 41 39.581H7C5.34315 39.581 4 38.2379 4 36.581V16H44V29.2723C44 29.8245 44.4477 30.2723 45 30.2723C45.5523 30.2723 46 29.8245 46 29.2723V11.0001C46 8.23861 43.7614 6 41 6H7ZM44 14V11.0001C44 9.34319 42.6569 8.00003 41 8.00003H7C5.34315 8.00003 4 9.34319 4 11.0001V14H44Z",
    fill: "#256BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.395 34.79C20.3183 34.79 17 31.4717 17 27.395C17 23.3182 20.3183 20 24.395 20C28.4718 20 31.7901 23.3183 31.7901 27.395C31.7901 31.4718 28.4718 34.79 24.395 34.79Z",
    fill: "#E9F0FF",
    stroke: "#256BFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8525 30.3945C23.5968 30.3945 23.3409 30.297 23.1458 30.1018L20.4353 27.3912C20.045 27.0009 20.045 26.3681 20.4353 25.9778C20.8256 25.5874 21.4584 25.5875 21.8488 25.9778L23.8526 27.9816L26.9416 24.8923C27.3319 24.502 27.9647 24.502 28.3551 24.8923C28.7454 25.2826 28.7454 25.9155 28.3551 26.3058L24.5593 30.1017C24.364 30.297 24.1082 30.3945 23.8525 30.3945Z",
    fill: "#256BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetGoing);
export default __webpack_public_path__ + "static/media/get_going.a7a79a6555e8bf88e502b9f3d9a1377d.svg";
export { ForwardRef as ReactComponent };